/**
 * Frontend functionality for SVT Delivery View
 */

import delegateListener from '../modules/delegate-listener';
//import TemplateHelper from '../modules/template-helper';
import MediaItem from '../api/mediaitem';
//import ModalHelper from '../modules/modal-helpers';
import SlideUnlock from '../modules/slide-unlock';
import Delivery from '../api/delivery';

class DeliveryView {
  constructor(deliveryId, options) {
    const defaults = {
      enabledPages: ['.page--order'],
      delegateListener: delegateListener,
      //templateHelper: new TemplateHelper(),
      //modalHelper: new ModalHelper(),
      //uploadInputSelector: '.item-images__upload-form input[name="image"]',
      deleteButtonSelector: '[data-remove-media]',
      mediaItemSelector: '.thumbnail-list__item',
      slideUnlock: new SlideUnlock({ unlockAction: this._changeDeliveryStatus.bind(this) }),
      delivery: new Delivery(deliveryId),
      deliveryDetailsInputs: '#keys_received,#extra_tires,#charging_cable_received', //checkboxes
      deliveryInputs: '#number_of_keys_received' //textual inputs
    };

    Object.assign(this, defaults, options);
  }

  /**
   * Attaches events if currently on an enabled page
   */
  init() {
    if(document.querySelectorAll(this.enabledPages.join(',')).length <= 0) {
      // short circuit initialization, as we're on a page that doesn't need this module.
      return;
    }

    // Initialize slide to unlock
    this.slideUnlock.init();

    // NOTE: modules/image-manager.js now handles multiple image uploads!
    // Initialize upload button
    // this.uploadInput = document.querySelector(this.uploadInputSelector);
    // if(this.uploadInput) {
    //   this.uploadInput.addEventListener('change', this._handleUploadInputChange.bind(this));
    // }

    document.body.addEventListener(
      'click', delegateListener(
        this.deleteButtonSelector,
        this._handleDeleteClick.bind(this)
      )
    );

    document.querySelectorAll(this.deliveryDetailsInputs).forEach(input => {
      input.addEventListener('change', this._handleDeliveryDetailsChange.bind(this));
    });

    // Bind events to textual input fields (throttled)
    if(document.querySelector(this.deliveryInputs)) {
      const inputChangeHandler = this._handleInputChange.bind(this);
      document.body.addEventListener('input', delegateListener(
        this.deliveryInputs, inputChangeHandler
      ));
    }
  }

  /**
   * Event handler for delivery details, such as whether all keys were returned
   * @param {Object} event - The event object
   */
  _handleDeliveryDetailsChange(event) {
    this._updateFieldValue(event.currentTarget.id, event.currentTarget.checked ? '1' : '0');
  }

  /**
   * Handles the event of changing the value of a textual input.
   * To prevent making AJAX requests for each character the user types,
   * the request is made only after the user has stopped typing for a
   * certain amount of time specified in the variable `throttlingTime`.
   *
   * @param {Event} event - The change or input event of an input field
   */
  _handleInputChange(event) {
    const throttlingTime = 300;
    const target = event.delegateTarget || event.currentTarget;

    window.clearTimeout(this._throttleInputChange);

    const updateFieldValue = this._updateFieldValue.bind(this);

    this._throttleInputChange = window.setTimeout(function() {
      updateFieldValue(target.id, target.value);
    }, throttlingTime);
  }

  /**
   * Updates the value of a single field
   *
   * @param {string} fieldName  The name of the field to update
   * @param {mixed}  value      The new value of the field
   */
  _updateFieldValue(fieldName, value) {
    const data = {};
    data[fieldName] = value;
    this.delivery.patch(data).then((res) => {
      /* This would be a good place to check for a successful response.. */
    });
  }



  /**
   * Change the status of the delivery. Used when the user uses the slide-to-unlock component.
   *
   * @param {string} slider The slider that was slided.
   */
  _changeDeliveryStatus(slider) {
    const newStatus = slider.container.dataset.newStatus;
    const deliveryStatusChangeHandler = this._handleDeliveryStatusChange.bind(this);
    this.delivery.patch({ status: newStatus }).then((response) => {
      deliveryStatusChangeHandler(response, slider)
    });
  }

  /**
   * Handle the response to the status change from the server.
   *
   * @param {Object} response Response to the status change from the server
   * @param {Object} slider The slider that was slid to unlock
   */
  _handleDeliveryStatusChange(response, slider) {
    if (response.status === 'OK') {
      // Update unlock text
      this.slideUnlock.enableUnlockedText(slider);

      // Enable next slider
      const nextSliderSelector = slider.container.dataset.enableSlider;
      if (nextSliderSelector) {
        this.slideUnlock.enable(this.slideUnlock.getSliderByContainer(document.querySelector(nextSliderSelector)));
      }
    }
    else {
      /* This would be a good place to display an error message */
    }
  }

  /**
   * Event handler for delete media item button
   *
   * @param {Event} event - The click event
   */
  _handleDeleteClick(event) {
    // Find target mediaId
    const mediaId = event.delegateTarget.dataset.removeMedia;
    if(!mediaId) { throw Error('MediaID not found'); }

    const mediaItem = new MediaItem(mediaId);
    const res = mediaItem.delete();
    res.then(response => {
      //this.removeMediaModals();
      if (response.status === 'OK') {
        this._removeItem(mediaId);
      }
      else {
        /* This would be a good place to tell the user that the operation failed */
      }
    });
  }

  /**
   * Removes a MediaItem's thumbnail from DOM
   *
   * @param {string} mediaId - The mediaId to be removed
   */
  _removeItem(mediaId) {
    const oldItem = Array.from(
      document.querySelectorAll(this.mediaItemSelector)
    ).filter(item => {
      return item.dataset.itemId === mediaId;
    })[0];
    if(oldItem) {
      oldItem.parentNode.removeChild(oldItem);
    }
  }
}

module.exports = DeliveryView;
